import { footerColumns } from '../../data/homepageData';
import { Logo } from '../ui/Logo';

export function SiteFooter() {
  return (
    <footer id="footer" className="site-footer">
      <div className="site-footer__brand">
        <Logo />
        <p>Měníme vzpomínky na příběhy, které zůstanou.</p>
        <div className="socials" aria-label="Sociální sítě">
          <span>f</span><span>◎</span><span>♪</span><span>p</span>
        </div>
      </div>
      {footerColumns.map((col) => (
        <div className="footer-col" key={col.title}>
          <h3>{col.title}</h3>
          {col.links.map((link) => <a key={link} href="#footer">{link}</a>)}
        </div>
      ))}
      <div className="newsletter">
        <h3>Newsletter</h3>
        <p>Buď první, kdo se dozví o novinkách a speciálních nabídkách.</p>
        <form>
          <input type="email" placeholder="Váš e-mail" aria-label="Váš e-mail" />
          <button type="submit" aria-label="Přihlásit k newsletteru">→</button>
        </form>
      </div>
      <div className="site-footer__bottom">
        <span>© 2026 Calendar Studio. Všechna práva vyhrazena.</span>
        <span>Obchodní podmínky</span>
        <span>Ochrana soukromí</span>
        <span>Cookies</span>
        <span>CZK</span>
        <span>Čeština</span>
      </div>
    </footer>
  );
}
